module.exports = __webpack_public_path__ + "img/img_tag_jiqiaopian.0e05a860.svg";